import React from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'rc-slider';
import domService from '../../../../services/DomService';
import stateCache from '../../../../services/StateCache';
import multimediaEvents from './MultimediaEvents';

const MASTER_VOLUME_STORAGE_KEY = 'MULTIMEDIA_MASTER_VOLUME';

/**
 * Volume control component.
 * Button + slider.
 */
class VolumeControl extends React.Component {
    static propTypes = {
        multimedia: PropTypes.object,
        services: PropTypes.object,
    };

    static defaultProps = { multimedia: undefined };

    constructor(props) {
        super(props);

        this.state = {
            multimediaVolume: this.getInitialVolume(),
            dragging: false,
        };
    }

    componentDidMount() {
        window.addEventListener(multimediaEvents.MASTER_VOLUME_CHANGE, this.onMasterVolumeChange);
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.multimedia !== this.props.multimedia) {
            nextProps.multimedia.volume = this.state.multimediaVolume;
        }
    }

    componentWillUnmount() {
        window.removeEventListener(multimediaEvents.MASTER_VOLUME_CHANGE, this.onMasterVolumeChange);
    }

    getInitialVolume = () => {
        const storedMasterVolume = parseFloat(
            stateCache
                .getStateCacheInstance()
                .getQuestionCacheValue(MASTER_VOLUME_STORAGE_KEY)
        );

        return isNaN(storedMasterVolume) ? 0.7 : storedMasterVolume;
    };

    changeVolumeLevel = (value, setDragging = true) => {
        if (setDragging) {
            this.setState({
                dragging: true,
            });
        }
        domService.dispatchEvent(window, multimediaEvents.MASTER_VOLUME_CHANGE, value);
    };

    onMasterVolumeChange = (e) => {
        const value = (typeof e.detail !== 'undefined') && !isNaN(e.detail) ? e.detail : this.state.multimediaVolume;
        const { stateCacheService } = this.props.services;
        this.setState({
            multimediaVolume: value,
        }, () => {
            stateCacheService.setQuestionCacheValue(MASTER_VOLUME_STORAGE_KEY, value);
            if (this.props.multimedia) {
                this.props.multimedia.volume = value;
            }
        });
    };

    onVolumeBtnClick = (evt) => {
        const { target } = evt;

        this.hasClickedOnSlider = domService.hasClass(target, 'volumeControl')
            || !!domService.getParentElementByClass(target, 'volumeControl');
        // don't do volume button click when either:
        // 1. user is dragging volume slider inside .volumeControl component.
        // 2. user is dragging volume slider but releases the button on top of the volume button.
        if (this.hasClickedOnSlider || (this.volumeSlider && this.volumeSlider.state.handle)) {
            return;
        }

        // toggle mute/unmute volume
        if (this.state.multimediaVolume === 0) {
            this.changeVolumeLevel(
                (this.oldVolumeLevel && this.oldVolumeLevel !== -1) ?
                    this.oldVolumeLevel :
                    this.getInitialVolume(), false);
        } else {
            this.oldVolumeLevel = this.props.multimedia ? this.props.multimedia.volume : -1;
            this.changeVolumeLevel(0, false);
        }
    };

    onVolumeSliderAfterChange = () => {
        this.setState({
            dragging: false,
        });
    };

    render() {
        const disabled = (typeof this.props.multimedia === 'undefined');
        const draggingClass = (this.state.dragging ? 'stayOpen' : '');
        // const volumeControlClass = (this.volumeSlider && this.volumeSlider.state.handle) ? 'volumeControl stayOpen' : 'volumeControl';
        let volumeOffClass;
        let volumeDownClass;
        let volumeUpClass;

        // update volume icon
        if (this.state.multimediaVolume === 0) {
            volumeOffClass = 'fa fa-volume-off fa-2x';
            volumeDownClass = 'fa fa-volume-down fa-2x hidden';
            volumeUpClass = 'fa fa-volume-up fa-2x hidden';
        } else if (this.state.multimediaVolume < 0.5) {
            volumeOffClass = 'fa fa-volume-off fa-2x hidden';
            volumeDownClass = 'fa fa-volume-down fa-2x';
            volumeUpClass = 'fa fa-volume-up fa-2x hidden';
        } else if (this.state.multimediaVolume >= 0.5 && this.state.multimediaVolume <= 1) {
            volumeOffClass = 'fa fa-volume-off fa-2x hidden';
            volumeDownClass = 'fa fa-volume-down fa-2x hidden';
            volumeUpClass = 'fa fa-volume-up fa-2x';
        }

        return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div className="volume playerButton" onMouseUp={this.onVolumeBtnClick}>
                <div className={`volumeControl ${draggingClass}`}>
                    <ReactSlider
                        ref={(volumeSlider) => { this.volumeSlider = volumeSlider; }}
                        defaultValue={this.getInitialVolume()}
                        value={this.state.multimediaVolume}
                        min={0}
                        max={1}
                        step={0.05}
                        vertical
                        disabled={disabled}
                        className={`volumeSlider ${draggingClass}`}
                        tipFormatter={null}
                        onChange={this.changeVolumeLevel}
                        onAfterChange={this.onVolumeSliderAfterChange}
                    />
                </div>
                <div className="volumeIcons">
                    <i className={volumeOffClass} />
                    <i className={volumeDownClass} />
                    <i className={volumeUpClass} />
                </div>
            </div>
        );
    }
}

export default VolumeControl;
